import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Summary',
  subtotal: 'Subtotal',
  shipping: 'Shipping',
  subtotalPrice: 'AU{dollarSign}{subtotal}',
})
